/**
 * The customer's words for its sector (PLAN-FINAL B7 "Words", Q50). The sector comes from the host
 * (via Console); this product keeps its own term map per sector as data. Sector keys are Console's
 * `interplay.sectors` list (e.g. primary_secondary, higher_education, business).
 *
 * Unknown or missing sectors get AnooreHR's own words (`business`), which are the labels the app
 * already uses, so a customer outside interplay sees no change.
 */
export interface SectorTerms {
  /** People, plural: the menu entry and table headings. */
  staff: string;
  /** One person. */
  staffOne: string;
  /** Organisational unit. */
  dept: string;
  depts: string;
  /** The working period. */
  period: string;
}

export const SECTOR_TERMS: Readonly<Record<string, SectorTerms>> = Object.freeze({
  business: { staff: 'Employees', staffOne: 'Employee', dept: 'Department', depts: 'Departments', period: 'Period' },
  primary_secondary: { staff: 'Staff', staffOne: 'Staff member', dept: 'Department', depts: 'Departments', period: 'Session' },
  higher_education: { staff: 'Staff', staffOne: 'Staff member', dept: 'Faculty', depts: 'Faculties', period: 'Session' },
});

export const DEFAULT_SECTOR = 'business';

const SECTOR_KEY = /^[a-z][a-z0-9_]{1,63}$/;

export function termsFor(sector?: string | null): SectorTerms {
  if (sector && SECTOR_KEY.test(sector) && Object.prototype.hasOwnProperty.call(SECTOR_TERMS, sector)) {
    return SECTOR_TERMS[sector];
  }
  return SECTOR_TERMS[DEFAULT_SECTOR];
}
